import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RaciTemplateService } from '../../../services/raci-template-service';

/**
 * Handles raci template edit component
 */
@Component({
  selector: 'raci-template-edit',
  templateUrl: './raci-template-edit.component.html',
  styleUrls: ['./raci-template-edit.component.css']
})
export class RaciTemplateEditComponent implements OnInit {
  /**
   * Selected template id
   */
  public selectedTemplateId: number;

  /**
   * Constructor
   * @param rtService
   */
  constructor(private rtService: RaciTemplateService) { }
  ngOnInit(): void {
    this.selectedTemplateId = this.rtService.getSelectedTemplateId();
  }

  /**
  * Should close?
  */
  shouldClose = false;

  /**
  * Close pane event listener
  */
  @Output()
  closePane: EventEmitter<any> = new EventEmitter();

  /**
  * Close with refresh evet listener
  */
  @Output()
  closeWithRefresh: EventEmitter<any> = new EventEmitter();

  /**
  * Close click event handler
  */
  onCloseClicked(): void {
    this.shouldClose = true;
    setTimeout(() => {
      this.closePane.emit();
    }, 500);//let animation finish
  }

  /**
   *  Close with refresh
   */
  onCloseWithRefresh() {
    this.closeWithRefresh.emit();
  }
}
